import AppStore from 'application_advertisement/app_store_budge.svg'
import GooglePlay from 'application_advertisement/google_play_store_budge.svg'
import chatIcon from 'icon_web_chat.png'
import _ from 'lodash'
import Grid from 'material-ui/Grid'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'
import moment from 'moment'
import React from 'react'
import ClintalApp from 'smartphone_app.png'
import { get, postFormData, put } from '../../modules/Api'
import images from '../common/images'
import styleSheet from './AllWebChatStyle.style'
import WebChatBotChoice from './WebChatBotChoice'
import WebChatChangeUserPlanModal from './WebChatChangeUserPlanModal'
import WebChatChat from './WebChatChat'
import WebChatChatModal from './WebChatChatModal'
import WebChatCreditCardModal from './WebChatCreditCardModal'
import WebChatNewConsultation from './WebChatNewConsultation'
import WebChatRegisterRecommendModal from './WebChatRegisterRecommendModal'
import WebChatSearchForm from './WebChatSearchForm'
import WebChatSend from './WebChatSend'
import WebChatUserPlan from './WebChatUserPlan'

const CLINTAL_BLUE = '#5A8DDA'

class WebChatIndex extends React.Component {
  state = {
    user_id: null,
    preveous_chats: [],
    chats: [],
    answerChoices: [],
    nurseChatMode: false,
    freeInputMode: false,
    plan_name: '',
    plan_price: '',
    plan_start_date: '',
    plan_end_date: '',
    staff_chat_count: '',
    planChangeModal: false,
    flag_has_card: false,
    sp_charge_type: '',
    userLoggedIn: true,
    chatModal: false,
    organization_plan: '',
    first: false,
    current_latitude: '',
    current_longitude: '',
    chat_limit: '',
    next_reset_date: '',
    flag_irregular: false,
    flag_trial_plan: true,
    can_call_previous_question: true,
    can_attach_picture: true,
  }

  async componentDidMount() {
    if (window.innerWidth < 813 && !this.props.nonModal) {
      this.onChange('chatModal', true)
    }
    this.accountUpload()
    this.getCurrentLocation()
    this.reloadChat()
  }

  getCurrentLocation() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.setState({
        current_latitude: position.coords.latitude,
        current_longitude: position.coords.longitude,
      })
    })
  }

  async accountUpload() {
    get('/api/web_chat/account', (response) => {
      if (response.data === undefined) {
        return this.setState({ userLoggedIn: false })
      }
      const {
        user_id,
        plan_name,
        plan_price,
        plan_start_date,
        plan_end_date,
        staff_chat_count,
        flag_has_card,
        sp_charge_type,
        organization_plan,
        chat_limit,
        next_reset_date,
        flag_irregular,
        flag_trial_plan,
      } = response.data.attributes
      this.setState(
        {
          user_id,
          plan_name,
          plan_price,
          plan_start_date,
          plan_end_date,
          staff_chat_count,
          flag_has_card,
          sp_charge_type,
          organization_plan,
          chat_limit,
          next_reset_date,
          flag_irregular,
          flag_trial_plan,
        },
        () => {
          this.setupSubscription(user_id)
        }
      )
    })
  }

  async reloadChat(optionUpdateObject = {}, scrollTo = true) {
    const chats = await this.getChats()
    const options = await this.getAnswerOptions()
    const freeInputType = 1
    let nurseChatMode,
      freeInputMode = false
    if (!options) nurseChatMode = true
    if (!!options && options[0].answer_type === freeInputType) freeInputMode = true
    if (!options) nurseChatMode = true

    this.setState({ chats: chats, answerChoices: options, nurseChatMode, freeInputMode, ...optionUpdateObject }, () => {
      const { scrollHeight, offsetHeight } = this.messageList
      scrollTo && this.messageList.scrollTo({ top: scrollHeight - offsetHeight })
    })
  }

  resetBotChat() {
    this.setState({ first: true })
    this.sendAnswer({ id: 64, bot_question_id: 15 })
  }

  async getChats(before_seq_num = null) {
    return new Promise((solve, reject) => {
      put(
        '/api/web_chat/chats/messages',
        {
          attributes: { per_page: 50, before_seq_num: before_seq_num },
        },
        (response) => solve(response.data)
      )
    })
  }

  async clickLikeButton(seq_num, is_liked, index) {
    this.update_chats_like(index)
    return new Promise((solve) => {
      put('/api/web_chat/chats/like', { attributes: { seq_num: seq_num, is_liked: !is_liked } }, () =>
        solve(this.reloadChat({}, false))
      )
    })
  }

  update_chats_like(index) {
    if (index < this.state.preveous_chats.length) {
      const preveous_chats = this.state.preveous_chats.slice()
      preveous_chats[index].attributes.like = !preveous_chats[index].attributes.like
      this.setState({ preveous_chats })
    }
  }

  async getAnswerOptions() {
    if (this.state.first == true) {
      this.setState({ first: false })
      return new Promise((solve, reject) => {
        get('/api/web_chat/bot/question?first=true', (response) => {
          solve(response.data.attributes.choices)
          this.reloadChat()
        })
      })
    } else {
      return new Promise((solve, reject) => {
        get('/api/web_chat/bot/question', (response) => {
          const can_call_previous_question = response.data.attributes.can_call_previous_question
          const question_type = response.data.attributes.question_type
          const can_attach_picture =
            question_type != 'clinic_triage_location_input_node' &&
            question_type != 'hospital_triage_location_input_node'

          if (can_call_previous_question == true) {
            this.setState({ can_call_previous_question: true })
          } else if (can_call_previous_question == false) {
            this.setState({ can_call_previous_question: false })
          }

          this.setState({ can_attach_picture: can_attach_picture })

          solve(response.data.attributes.choices)
        })
      })
    }
  }

  getPreviousQuestion() {
    put(
      '/api/web_chat/bot/answer',
      {
        latitude: this.state.current_latitude,
        longitude: this.state.current_longitude,
        call_previous_question: true,
      },
      (response) => {
        this.reloadChat()
      }
    )
  }

  sendAnswer(choice, message = '') {
    put(
      '/api/web_chat/bot/answer',
      {
        bot_choice_id: choice.id,
        bot_question_id: choice.bot_question_id,
        free_answer: message,
        latitude: this.state.current_latitude,
        longitude: this.state.current_longitude,
      },
      (response) => {
        this.reloadChat()
      }
    )
  }

  async sendMessage(message, imageUri) {
    const { staff_chat_count } = this.state
    const today = moment(new Date()).format('YYYY-MM-DD')
    if (staff_chat_count === 0 || today > this.state.plan_end_date) {
      // カードをユーザーが所持していなかったらボタンイベントリスナーを追加
      await this.setState({ planChangeModal: true }, () => {
        const form = document.getElementById('payjp_card_form')
        if (!!form) {
          const script = document.createElement('script')
          script.innerHTML = "document.getElementById('payjp_send_card').addEventListener('click', create_card);"
          form.appendChild(script)
        }
      })

      return
    }

    if (!message && !imageUri) return

    postFormData('/api/web_chat/chats/staff_reply', this.genStaffReplyFormData(message, imageUri), (response) =>
      this.reloadChat({ staff_chat_count: staff_chat_count - 1 })
    )
  }

  async handleWebChatChatsScroll() {
    const { scrollTop } = this.messageList
    const scrollHeightBefore = this.messageList.scrollHeight
    if (scrollTop === 0) {
      const { chats, preveous_chats } = this.state
      const last_seq_num =
        preveous_chats.length === 0 ? chats[0].attributes.seq_num : preveous_chats[0].attributes.seq_num
      const additional_preveous_chats = await this.getChats(last_seq_num)
      this.setState({ preveous_chats: additional_preveous_chats.concat(preveous_chats) }, () => {
        const scrollHeightAfter = this.messageList.scrollHeight
        this.messageList.scrollTo({ top: scrollHeightAfter - scrollHeightBefore })
      })
    }
  }

  genStaffReplyFormData(message, imageUri = null, fileName = null) {
    let params = new FormData()
    params.append('attributes[message]', message)
    params.append('attributes[user_id]', this.state.user_id)
    if (imageUri) {
      params.append('attributes[uploads][image]', imageUri)
    }
    return params
  }

  onChange(fieldName, value) {
    this.setState({ [fieldName]: value })
  }

  setupSubscription(user_id) {
    App.cable.subscriptions.create(
      { channel: 'ChatUserChannel', user_id: user_id },
      {
        received: () => {
          this.reloadChat()
        },
      }
    )
  }

  render() {
    const plan_start_date = moment(this.state.plan_start_date).format('YYYY/MM/DD')
    const plan_end_date = moment(this.state.plan_end_date).format('YYYY/MM/DD')
    const next_reset_date = moment(this.state.next_reset_date).format('YYYY/MM/DD')
    const {
      chats,
      nurseChatMode,
      answerChoices,
      preveous_chats,
      freeInputMode,
      plan_name,
      plan_price,
      can_call_previous_question,
      can_attach_picture,
      staff_chat_count,
      planChangeModal,
      flag_has_card,
      sp_charge_type,
      userLoggedIn,
      chatModal,
      organization_plan,
      chat_limit,
      flag_irregular,
      flag_trial_plan,
    } = this.state
    const inputMode = nurseChatMode || freeInputMode
    const classes = this.props.classes
    /**
     * WebChat モーダル切替を使用しない設定です。連携モバイルアプリの WebView 表示に使用されます。
     * @type {boolean}
     */
    const nonModal = this.props.nonModal

    return (
      <div>
        <div className={nonModal ? classes.webView_webChatIndex : classes.webChatIndex}>
          <Grid container spacing={16}>
            <Grid item xs={12} md={8}>
              <div className={nonModal ? classes.webView_chatOpen : classes.chatOpen}>
                <button
                  className={`btn btn-primary ${classes.chatOpenbutton}`}
                  onClick={() => {
                    this.onChange('chatModal', !chatModal)
                  }}
                >
                  <img src={chatIcon} height={30} width={30} style={{ marginRight: 10 }} />
                  チャット画面を開く
                </button>
              </div>

              <Paper className={nonModal ? classes.webView_index_paper : classes.index_paper}>
                <Grid container>
                  <Grid item className={classes.index_chatTitle} xs={12}>
                    <div>
                      <Typography className={`mplus-bold ${classes.textBlue}`}>
                        <b style={{ fontSize: 18 }}>チャットで相談</b>
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12} className={classes.index_chatLogs}>
                    <div
                      className={classes.index_chatScroll}
                      ref={(el) => {
                        this.messageList = el
                      }}
                      onScroll={_.throttle((event) => this.handleWebChatChatsScroll(), 500)}
                    >
                      <WebChatChat
                        chats={preveous_chats.concat(chats)}
                        clickLikeButton={(chats_id, is_liked, index) => this.clickLikeButton(chats_id, is_liked, index)}
                      />
                    </div>
                  </Grid>

                  {nonModal ?
                    <div className={classes.chatModal_date}>
                      <img src={images.icNurse} height={22} width={22} className={classes.chatModal_nurseImg} />
                      看護師相談：<span className={classes.chatModal_dateContent}>残り{staff_chat_count}回</span>
                      　ご利用可能期間：<span className={classes.chatModal_dateContent}>{plan_end_date}まで</span>
                    </div>
                  : null}

                  {!chatModal ?
                    <Grid item xs={12} className={classes.index_chatChoice}>
                      {!inputMode ?
                        <WebChatBotChoice
                          answerChoices={answerChoices}
                          getPreviousQuestion={() => this.getPreviousQuestion()}
                          sendAnswer={(choice) => this.sendAnswer(choice)}
                          current_longitude={this.state.current_longitude}
                          current_latitude={this.state.current_latitude}
                        />
                      : nurseChatMode ?
                        <WebChatSend
                          reloadChat={() => this.reloadChat()}
                          getPreviousQuestion={() => this.getPreviousQuestion()}
                          sendMessage={(message, imageUrl) => this.sendMessage(message, imageUrl)}
                          can_attach_picture={can_attach_picture}
                        />
                      : freeInputMode ?
                        <WebChatSend
                          reloadChat={() => this.reloadChat()}
                          getPreviousQuestion={() => this.getPreviousQuestion()}
                          sendMessage={(message) => this.sendAnswer(answerChoices[0], message)}
                          can_attach_picture={can_attach_picture}
                        />
                      : null}
                    </Grid>
                  : null}
                  <div className={`${classes.index_chat_control_btns}`}>
                    {can_call_previous_question == true ?
                      <Grid className={`${classes.index_chatPrevious} btn`} onClick={() => this.getPreviousQuestion()}>
                        <div>
                          <Typography type={nonModal && 'caption'} className={`mplus-bold ${classes.textBlue}`}>
                            <b>1つ前の選択肢に戻る</b>
                          </Typography>
                        </div>
                      </Grid>
                    : <Grid className={`${classes.index_block_previous} btn`}>
                        <div>
                          <Typography type={nonModal && 'caption'} className={`mplus-bold ${classes.textGray}`}>
                            <b>1つ前の選択肢に戻る</b>
                          </Typography>
                        </div>
                      </Grid>
                    }

                    <Grid item className={`${classes.index_chatReset} btn`} onClick={() => this.resetBotChat()}>
                      <div>
                        <Typography type={nonModal && 'caption'} className={`mplus-bold ${classes.textBlue}`}>
                          <b>チャットを最初からやり直す</b>
                        </Typography>
                      </div>
                    </Grid>
                  </div>
                </Grid>
              </Paper>
            </Grid>

            {nonModal ? null : (
              <Grid className="side-bar" item xs={12} md={4}>
                <Grid container spacing={16}>
                  <Grid item xs={12}>
                    <Paper className={classes.index_sideBar}>
                      <WebChatUserPlan
                        plan_name={plan_name}
                        flag_trial_plan={flag_trial_plan}
                        plan_price={plan_price}
                        plan_start_date={plan_start_date}
                        plan_end_date={plan_end_date}
                        staff_chat_count={staff_chat_count}
                        chat_limit={chat_limit}
                      />
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper className={classes.index_sideBar}>
                      <WebChatSearchForm />
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper className={classes.index_sideBar}>
                      <WebChatNewConsultation />
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper className={classes.index_sideBar}>
                      <div>
                        <img className={classes.index_clintalApp} src={ClintalApp} />
                        <div className={classes.index_appImgBox}>
                          <div className={classes.index_appIos}>
                            <a
                              href="https://play.google.com/store/apps/details?id=com.clintal.android&hl=ja"
                              target="_brank"
                            >
                              <img src={GooglePlay} style={{ height: 40 }} />
                            </a>
                          </div>
                          <div className={classes.index_appAndroid}>
                            <a
                              href="https://itunes.apple.com/jp/app/%E3%82%AF%E3%83%AA%E3%83%B3%E3%82%BF%E3%83%AB-%E3%82%88%E3%82%8A%E3%82%88%E3%81%84%E5%8C%BB%E7%99%82%E3%82%92%E6%B1%82%E3%82%81%E3%82%8B%E4%BA%BA%E3%81%AE%E3%81%9F%E3%82%81%E3%81%AB/id1150987459?mt=8"
                              target="_blank"
                            >
                              <img src={AppStore} style={{ height: 41 }} />
                            </a>
                          </div>
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {/* ログインしていない状態で、WebChatのURLへとアクセスすると表示する */}
            <WebChatRegisterRecommendModal
              userLoggedIn={userLoggedIn}
              onChange={(fieldName, value) => this.onChange(fieldName, value)}
            />

            {/* Userが月額プランに入会していてかつ、健康相談チャットの残り回数が０の時にメッセージを送信しようとすると表示
                Userが法人プランに入会していてかつ、健康相談チャットの残り回数が０の時にメッセージを送信しようとすると表示
                Userが例外法人の月額プランに入会していてかつ、健康相談チャットの残り回数が０の時にメッセージを送信しようとすると表示 */}
            <WebChatCreditCardModal
              planChangeModal={planChangeModal}
              onChange={(fieldName, value) => this.onChange(fieldName, value)}
              setUp={() => this.accountUpload()}
              flag_has_card={flag_has_card}
              organization_plan={organization_plan}
              sp_charge_type={sp_charge_type}
              next_reset_date={next_reset_date}
              flag_irregular={flag_irregular}
            />

            {/* Userがお試しプランに入会していてかつ、有効期限が切れているときにチャットを送信しようとすると表示
                Userがお試しプランに入会していてかつ、健康相談チャットの残り回数が０の時にメッセージを送ろうとすると表示
                Userが例外法人のお試しプランに入会していてかつ、健康相談チャットの残り回数が０の時にメッセージを送信しようとすると表示 */}
            <WebChatChangeUserPlanModal
              planChangeModal={planChangeModal}
              onChange={(fieldName, value) => this.onChange(fieldName, value)}
              flag_has_card={flag_has_card}
              organization_plan={organization_plan}
              sp_charge_type={sp_charge_type}
              flag_irregular={flag_irregular}
            />
          </Grid>
        </div>

        {/* スマホレイアウト時のWebチャット */}
        <WebChatChatModal
          onChange={(fieldName, value) => this.onChange(fieldName, value)}
          chatModal={this.state.chatModal}
          clickLikeButton={(seq_num, is_liked, index) => this.clickLikeButton(seq_num, is_liked, index)}
          stateList={this.state}
          reloadChat={() => this.reloadChat()}
          sendAnswer={(choise, message) => this.sendAnswer(choise, message)}
          sendMessage={(message, imageUri) => this.sendMessage(message, imageUri)}
          handleWebChatChatsScroll={() => this.handleWebChatChatsScroll()}
          getChats={(before_seq_num) => this.getChats(before_seq_num)}
          resetBotChat={() => this.resetBotChat()}
          plan_end_date={this.state.plan_end_date}
          next_reset_date={next_reset_date}
          getAnswerOptions={() => this.getAnswerOptions()}
          current_longitude={this.state.current_longitude}
          current_latitude={this.state.current_latitude}
          getPreviousQuestion={() => this.getPreviousQuestion()}
          can_call_previous_question={can_call_previous_question}
          can_attach_picture={can_attach_picture}
          flag_trial_plan={flag_trial_plan}
        />
      </div>
    )
  }
}
export default withStyles(styleSheet)(WebChatIndex)
